export default __webpack_public_path__ + "static/aikido-dean-423f3bdb1e54076f36a0cf165ef3bdf9.jpg";